// import { Component, OnInit } from '@angular/core';
import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import {MegaMenuItem,MenuItem} from 'primeng/api';
import { ApiService } from 'src/app/api.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  displayBasic: boolean;
  payment: boolean = false;
  assets: boolean = false;
  assets1: boolean = false;
  assets2: boolean = false;

  matMenu : any;


  public doughnutChartLabels = ['Sales Q1', 'Sales Q2', 'Sales Q3', 'Sales Q4'];
  public doughnutChartData = [120, 150, 180, 90];
  public doughnutChartType = 'doughnut';


  public radarChartLabels = ['Q1', 'Q2', 'Q3', 'Q4'];
  public radarChartData = [
    {data: [120, 130, 180, 70], label: '2017'},
    {data: [90, 150, 200, 45], label: '2018'}
  ];
  public radarChartType = 'radar';



  public pieChartLabels = ['Sales Q1', 'Sales Q2', 'Sales Q3', 'Sales Q4'];
  public pieChartData = [120, 150, 180, 90];
  public pieChartType = 'pie';

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData = [
    {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'},
    {data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B'}
  ];

  rows: any = [{ type: "Dog", name: "dog1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" },
  { type: "Cat", name: "cat1" }];
  searchQR: any;


  data:any = {
    labels: ['A','B','C'],
    datasets: [
        {
            data: [300, 50, 100],
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ],
            hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ]
        }]
    };


    data1:any = {
      labels: ['January', 'February', 'March',],
      datasets: [
          {
              label: 'My First dataset',
              backgroundColor: '#42A5F5',
              borderColor: '#1E88E5',
              data: [65, 59, 80,]
          },
          {
              label: 'My Second dataset',
              backgroundColor: '#9CCC65',
              borderColor: '#7CB342',
              data: [28, 48, 40,]
          }
      ]
  }

  data2:any= {
    labels: ['A','B','C'],
    datasets: [
        {
            data: [300, 50, 100],
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ],
            hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ]
        }]
    };



  items: MegaMenuItem[];
  login_detail:any;
  DashboardData: any;
  dashboardgetCount: any;
  PTPcount: any[];
  PTPDetails: any[];
  displayPTPDialog: boolean = false;
  allocatedDetails: any[];
  notAllocatedDetails: any[];
  touchedDetails: any[];
  notTouchedDetails: any[];
  displayAllocatedDialog: boolean = false;
  displayNotAllocatedDialog: boolean = false;
  displayTouchedDialog: boolean = false;
  displayNotTouchedDialog: boolean = false;
  SRcount: any;
  SCcount: any;
  FVRcount: any;
  FVCcount: any;
  AllocationStatus: any;
  datas: any;
  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) { }
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.login_detail = this.getFromLocal("login_detail");
    const data = {
      assigned_by: this.login_detail._id
    }
    this._api.getDashboardCount(data).subscribe(data=>{
      if (data['Code'] == 200) {
        this.DashboardData = data['Data'];
        console.log(this.DashboardData);

      } else {
        this.DashboardData = [];
      }
    });
this.datas = this.login_detail._id

console.log(this.datas,"datadatadatadatadata");

    this._api.dashboardgetCount(this.datas).subscribe(data=>{
      if (data['Code'] == 200) {
        this.dashboardgetCount = data['Data'];
      } else {
        this.dashboardgetCount = [];
      }
    });







    this.ptp();
    this.settlement_approved();
    this.settlement_raised();
    this.fieldvisit_approved();
    this.fieldvisit_raised();

    // Clear any existing storage flags first
    this.storage.remove('showPTPDetails');
    this.storage.remove('expandWorkflowRelated');

    // Check if PTP details should be shown (only from notification click)
    setTimeout(() => {
      const showPTPDetails = this.getFromLocal('showPTPDetails');
      const expandWorkflowRelated = this.getFromLocal('expandWorkflowRelated');
      if (showPTPDetails) {
        this.displayPTPDialog = true;
        this.storage.remove('showPTPDetails');
      }
      if (expandWorkflowRelated) {
        this.assets = true;
        this.storage.remove('expandWorkflowRelated');
        // Scroll to PTP card after a delay to allow DOM to update
        setTimeout(() => {
          const element = document.getElementById('ptp-card');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500);
      }
    }, 200);
  }
  saveInLocal(key, val): void {
      this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  outstand_value(){

  }

  account_count(){

  }

  settlement_raised(){
    const data = {
      user_id: this.login_detail._id
    }
    this._api.dashboardgetCount(data).subscribe(data=>{
      this.SRcount = data['Data']
      // console.log(this.SRcount.WaitingcreatenewSettle);


    });
  }

  settlement_approved(){
    const data = {
      user_id: this.login_detail._id
    }
    this._api.dashboardgetCount(data).subscribe(data=>{

        this.SCcount = data['Data'];
        // console.log("data", this.SCcount);


    });
  }

  fieldvisit_raised(){
    const data = {
      user_id: this.login_detail._id
    }
    this._api.getFieldVisitRaised(data).subscribe(data=>{
      if (data['Code'] == 200) {
        this.FVRcount = data['Data'];
      } else {
        this.FVRcount = [];
      }
    });
  }

  fieldvisit_approved(){
    const data = {
      user_id: this.login_detail._id
    }
    this._api.getFieldVisitApproved(data).subscribe(data=>{
      if (data['Code'] == 200) {
        this.FVCcount = data['Data'];
      } else {
        this.FVCcount = [];
      }
    });
  }

  ptp(){
    const data = {
      user_id: this.login_detail._id
    }
    this._api.getPTPcount(data).subscribe(data=>{

        this.PTPcount = data['Data']?.count;
        this.PTPDetails = data['Data']?.details || [];
     console.log("PTP", this.PTPcount);


    });
  }


  payment_count(){

  }















  dash() {
    // if(this.name == 'salveo@gmail.com' && this.password == '123456'){
    //   this.router.navigate(['admin_panel']);
    // }
    // else{
    //   alert('Invalid Login Details')
    // }
    // this.router.navigate(['admin_panel/accounts/accounts']);
  }

  logout() {
    this.router.navigate(['']);
  }
  Entity_List() {
    //this.router.navigate(['admin_panel/Super_admin/EntityManagement']);
  }
  Add_Entity() {
    //this.router.navigate(['admin_panel/Super_admin/EntityForm']);
  }
  Client_List() {
    //this.router.navigate(['admin_panel/Clients']);
  }
  Add_Client() {
    //this.router.navigate(['admin_panel/client-form']);
  }
  accallocate() {
    //this.router.navigate(['admin_panel/userflow/accallocate']);
  }
  accworked() {
    //this.router.navigate(['admin_panel/userflow/accworked']);
  }
  accpending() {
    //this.router.navigate(['admin_panel/userflow/accpending']);
  }
  accptptoken() {
    //this.router.navigate(['admin_panel/userflow/accptptoken']);
  }

  creditcardlist() {
    //this.router.navigate(['admin_panel/userflow/creditcardlist']);
  }
  vehicleloanlist() {
    //this.router.navigate(['admin_panel/userflow/vehicleloanlist']);
  }
  personalloanlist() {
    //this.router.navigate(['admin_panel/userflow/personaloanlist']);
  }
  homeloanlist() {
    //this.router.navigate(['admin_panel/userflow/homeloanlist']);
  }
  subsriptionlist() {
    // this.router.navigate(['']);
  }
  organlist() {
    // this.router.navigate(['']);
  }
  clientlist() {
    //this.router.navigate(['admin_panel/Clients']);
  }
  userlist() {
    // this.router.navigate(['']);
  }

  showBasicDialog() {
    //this.displayBasic = true;
  }
  Adhoc() {
    //this.router.navigate(['admin_panel/user/adhoc']);
  }

  pay() {
    this.payment = !this.payment;
  }

  asset() {
    this.assets = !this.assets;
  }

  asset1() {
    this.assets1 = !this.assets1;
  }

  asset2() {
    this.assets2 = !this.assets2;
  }

  showPTPDetails() {
    this.displayPTPDialog = !this.displayPTPDialog;
  }

  showAllocatedDetails() {
    this.allocatedDetails = this.DashboardData?.allocated_details || [];
    this.allocatedDetails.forEach((item) => {
      if (item.customer_details && item.customer_details.length > 0) {
        let name = JSON.parse(item.customer_details[0]);
        item['Cr. Card Dues'] = name[0]['Cr. Card Dues'] || "";
        item['Loan Dues'] = name[0]['Loan Dues'] || "";
        item['A/c Segment'] = name[0]['A/c Segment'] || "";
        item['Qatar Mobile No'] = name[0]['Qatar Mobile No'] || "";
        item['Email ID'] = name[0]['Email ID'] || "";
        item['Status Of Accounts'] = name[0]['Status Of Accounts'] || "";
        item.Contactable = name[0].Contactable || "";
        item['Short Code'] = name[0]['Short Code'] || "";
      }
    });
    this.displayAllocatedDialog = !this.displayAllocatedDialog;
    this.displayNotAllocatedDialog = false;
    this.displayTouchedDialog = false;
    this.displayNotTouchedDialog = false;
  }

  showNotAllocatedDetails() {
    this.notAllocatedDetails = this.DashboardData?.not_allocated_details || [];
    this.notAllocatedDetails.forEach((item) => {
      if (item.customer_details && item.customer_details.length > 0) {
        let name = JSON.parse(item.customer_details[0]);
        item['Cr. Card Dues'] = name[0]['Cr. Card Dues'] || "";
        item['Loan Dues'] = name[0]['Loan Dues'] || "";
        item['A/c Segment'] = name[0]['A/c Segment'] || "";
        item['Qatar Mobile No'] = name[0]['Qatar Mobile No'] || "";
        item['Email ID'] = name[0]['Email ID'] || "";
        item['Status Of Accounts'] = name[0]['Status Of Accounts'] || "";
        item.Contactable = name[0].Contactable || "";
        item['Short Code'] = name[0]['Short Code'] || "";
      }
    });
    this.displayNotAllocatedDialog = !this.displayNotAllocatedDialog;
    this.displayAllocatedDialog = false;
    this.displayTouchedDialog = false;
    this.displayNotTouchedDialog = false;
  }

  showTouchedDetails() {
    this.touchedDetails = this.DashboardData?.touched_details || [];
    this.touchedDetails.forEach((item) => {
      if (item.customer_details && item.customer_details.length > 0) {
        let name = JSON.parse(item.customer_details[0]);
        item['Cr. Card Dues'] = name[0]['Cr. Card Dues'] || "";
        item['Loan Dues'] = name[0]['Loan Dues'] || "";
        item['A/c Segment'] = name[0]['A/c Segment'] || "";
        item['Qatar Mobile No'] = name[0]['Qatar Mobile No'] || "";
        item['Email ID'] = name[0]['Email ID'] || "";
        item['Status Of Accounts'] = name[0]['Status Of Accounts'] || "";
        item.Contactable = name[0].Contactable || "";
        item['Short Code'] = name[0]['Short Code'] || "";
      }
    });
    this.displayTouchedDialog = !this.displayTouchedDialog;
    this.displayAllocatedDialog = false;
    this.displayNotAllocatedDialog = false;
    this.displayNotTouchedDialog = false;
  }

  showNotTouchedDetails() {
    this.notTouchedDetails = this.DashboardData?.not_touched_details || [];
    this.notTouchedDetails.forEach((item) => {
      if (item.customer_details && item.customer_details.length > 0) {
        let name = JSON.parse(item.customer_details[0]);
        item['Cr. Card Dues'] = name[0]['Cr. Card Dues'] || "";
        item['Loan Dues'] = name[0]['Loan Dues'] || "";
        item['A/c Segment'] = name[0]['A/c Segment'] || "";
        item['Qatar Mobile No'] = name[0]['Qatar Mobile No'] || "";
        item['Email ID'] = name[0]['Email ID'] || "";
        item['Status Of Accounts'] = name[0]['Status Of Accounts'] || "";
        item.Contactable = name[0].Contactable || "";
        item['Short Code'] = name[0]['Short Code'] || "";
      }
    });
    this.displayNotTouchedDialog = !this.displayNotTouchedDialog;
    this.displayAllocatedDialog = false;
    this.displayNotAllocatedDialog = false;
    this.displayTouchedDialog = false;
  }

  exportTable(table: any, data: any) {
    try {
      if (!data || !Array.isArray(data) || data.length === 0) {
        console.warn('No data to export');
        return;
      }

      // Manual CSV export
      const headers = ['S.No', 'Account No', 'CIF', 'Passport No', 'Customer Name', 'Banker Name', 'Date of Allocation'];
      const csvContent = [
        headers.join(','),
        ...data.map((row, index) => [
          index + 1,
          row.acc_no || '',
          row.cif || '',
          row.passport_no || '',
          row.customer_name || '',
          row.banker_name || '',
          row.date_of_allocations || ''
        ].map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'export.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Export error:', error);
    }
  }

}
